import Button from "../buttons/Button";

interface EntityActionsProps {
  onEdit(): void;
  onDelete(): void;

  editing?: boolean;
  deleting?: boolean;
}

export default function EntityActions({
  onEdit,
  onDelete,
  editing,
  deleting,
}: EntityActionsProps) {
  return (
    <div className="flex gap-2">

      <Button
        variant="secondary"
        onClick={onEdit}
        disabled={editing}
      >
        Edit
      </Button>

      <Button
        variant="danger"
        onClick={onDelete}
        disabled={deleting}
      >
        Delete
      </Button>

    </div>
  );
}